import { HomePage } from "./../home/home";
import { TranslateService } from "@ngx-translate/core";
import { RequestOptions, Http, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController, LoadingController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-plaza-overview-cash",
  templateUrl: "plaza-overview-cash.html",
})
export class PlazaOverviewCashPage {
  budget: any = "";
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLPlazaStatBudgets;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.budget = this.services.currencyFormat(data.available);
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  doRefresh(refresher) {
    this.storage.get("token").then((token) => {
      var link = this.services.URLPlazaStatBudgets;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.budget = this.services.currencyFormat(data.available);
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
    refresher.complete();
  }

  backPage() {
    this.navCtrl.pop();
  }

  homePage() {
    this.navCtrl.setRoot(HomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-overview-cash/plaza-overview-cash.ts